export const getTournamentPrizePool = (medals: { money?: number | null }[]) =>
  medals.reduce((acc, i) => acc + (i?.money ?? 0), 0);
